import OrderLineFormSubCont from '../../../../components/Sales/Orders/AddOrder/OrderLineFormSubCont'
import CustomDebounceSelect from '../../../../elements/Select/CustomDebounceSelect'
import React, { Component } from 'react'
import { Form, Select } from 'antd'
import { compose, withState } from 'recompose'
import { get } from 'lodash'
import { numVal, sessionItem, strVal } from '../../../../modules/Utils'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withMapList from '../../../../elements/HOC/withMapList'

class OrderLineForm extends Component {
  state = {
    ProductsLinesSelect: Select,
    QuoteLinesSelect: Select,
    VehiclesSelect: Select,
    ClientBudgetsSelect: Select,
    category: {},
    endOpen: false,
  }

  async componentDidMount () {
    await this.onChangeProducts(get(this.props.line, 'product._id'))
    await this.onChangeService(
      get(this.props.line, 'uom') || get(this.props.line, 'booking.ref.key'),
    )

    this.setState({
      ClientBudgetsSelect: compose(
        withUrlFetch({
          name: 'clientBudgets',
          url: `clientBudgets?select=*&contract=${strVal(
            this.props,
            'order.contract._id',
          )}&reference=${strVal(this.props, 'order.reference.no')}`,
          forceFetch: true,
          cache: false,
        }),
        withSpinning,
        withSort,
      )(CustomSelect),
      QuoteLinesSelect: compose(
        withUrlFetch({
          name: 'quoteLines',
          url: `${strVal(this.props, 'order.quote._id')}/lines`,
          forceFetch: true,
          cache: true,
        }),
        withSpinning,
        withSort,
        withMapList(l => ({ ...l, display: `[${l.quote.code}] ${l.name}` })),
      )(CustomSelect),
      VehiclesSelect: compose(
        withUrlFetch({
          name: 'vehicles',
          url: 'vehicles?select=*',
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort,
      )(CustomSelect),
    })
  }

  onChangeService = key => {
    const { current } = this.props.formRef
    const rates = current
      ? get(
      JSON.parse(
        sessionStorage[`clients_${current.getFieldValue('contract._id')}_dropdown`] || '{}',
      ),
      'rates',
    ) || []
      : []
    const service = rates.find(r => r.key === key)
    this.setState({
      service,
      category: get(service, 'product.category'),
    })
    !this.props.form.getFieldValue('rate') &&
    this.props.form.setFieldsValue({
      rate: numVal(service, 'rate'),
    })
  }
  onChangeVehicles = vehicleID => {
    this.props.form.resetFields(['vehicle.plate', 'salik'])
    if (vehicleID) {
      const vehicle = sessionItem(`vehicles_vehicles?select=*_dropdown`, vehicleID, '_id')
      this.props.form.setFieldsValue({
        'booking.vehicle.plate': get(vehicle, 'salik.plate'),
        'booking.salik.tag': get(vehicle, 'salik.tag'),
      })
    }
  }
  onChangeProducts = productID => {
    this.props.form.resetFields(['uom', 'rate'])
    if (productID) {
      const product = sessionItem(`products_${this.props.productsURL}_dropdown`, productID, '_id')
      const productsUrl = `products/lines?product=${productID}&select=*`
      const ProductsLinesSelect = compose(
        withUrlFetch({
          name: 'products_lines',
          url: productsUrl,
          forceFetch: true,
          cache: true,
        }),
      )(CustomSelect)
      this.setState({
        ProductsLinesSelect,
        product,
        productsUrl,
        category: get(product, 'category'),
      })
    } else {
      this.setState({ ProductsLinesSelect: Select })
    }
  }

  onChangeLineUOM = productLineID => {
    const productLine = sessionItem(
      `products_lines_${this.state.productsUrl}_dropdown`,
      productLineID,
      '_id',
    )
    this.props.form.setFieldsValue({
      'tax.rate': get(productLine, 'tax.value'),
      rate: this.props.form.getFieldValue('rate') || get(productLine, 'price'),
      'tax.type': get(productLine, 'tax.type'),
      unit: undefined,
    })
    this.setState({
      price: productLine,
    })
  }

  disabledStartDate = startValue => {
    const endValue = this.props.form.getFieldValue('booking.dropoff.date')
    if (!startValue || !endValue) {
      return false
    }
    return startValue.valueOf() > endValue.valueOf()
  }
  disabledEndDate = endValue => {
    const startValue = this.props.form.getFieldValue('booking.pickup.date')
    if (!endValue || !startValue) {
      return false
    }
    return endValue.valueOf() <= startValue.valueOf()
  }
  onChange = (field, value) => {
    this.props.form.setFieldsValue({
      [field]: value,
    })
  }
  onStartChange = value => {
    this.onChange('booking.pickup.date', value)
  }
  onEndChange = value => {
    this.onChange('booking.dropoff.date', value)
    const days = this.props.form
      .getFieldValue('booking.dropoff.date')
      .diff(this.props.form.getFieldValue('booking.pickup.date'), 'd')
    this.setState({
      days: days + 1,
    })
  }
  handleStartOpenChange = open => {
    if (!open) {
      this.setState({ endOpen: true })
    }
  }
  handleEndOpenChange = open => {
    this.setState({ endOpen: open })
  }
  onChangeQuoteLine = async qlID => {
    if (!qlID) return
    const sessionKey = `quoteLines_${strVal(this.props, 'order.quote._id')}/lines_dropdown`
    const item = sessionItem(sessionKey, qlID, '_id')
    await this.props.onChangeProductType(item.productType)
    await this.props.onChangeProductCategory(item.category._id)
    await this.props.onChangeProductGroup(item.group._id)
    await this.onChangeProducts(item.product._id)
    console.log({ item })
    this.props.form.setFieldsValue({
      productType: item.productType,
      'product._id': item.product._id,
      'productLine._id': item.productLine._id,
      'product.category._id': item.category._id,
      'product.group._id': item.group._id,
      rate: item.rate,
      unit: item.unit,
    })
  }

  render () {
    const {
      line,
      category,
      ServicesSelectCmp,
      addDestination,
      removeDestination,
      handleLocationChange,
      onChangeProductCategory,
      onChangeProductGroup,
      onChangeDestinations,
      lineFormRef,
      order,
    } = this.props

    const {
      onChangeService,
      onChangeVehicles,
      onChangeProducts,
      onChangeLineUOM,
      onChangeUnit,
      disabledStartDate,
      disabledEndDate,
      onChange,
      onStartChange,
      onEndChange,
      handleStartOpenChange,
      handleEndOpenChange,
      onChangeQuoteLine,
    } = this

    const headerLinesUrl = `bookings/${order._key}/lines/?isHeader=true`
    const HeaderLinesSelect = compose(
      withUrlFetch({
        name: 'headerLines',
        url: headerLinesUrl,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort,
    )(CustomDebounceSelect)

    const {
      service,
      ProductsLinesSelect,
      QuoteLinesSelect,
      VehiclesSelect,
      ClientBudgetsSelect,
      total,
      endOpen,
      price,
      days,
    } = this.state

    return (
      <OrderLineFormSubCont
        ref={lineFormRef}
        {...{
          onChangeService,
          onChangeVehicles,
          onChangeProducts,
          onChangeLineUOM,
          disabledStartDate,
          disabledEndDate,
          onChange,
          onStartChange,
          onEndChange,
          handleStartOpenChange,
          handleEndOpenChange,
          onChangeQuoteLine,
          service,
          ProductsLinesSelect,
          QuoteLinesSelect,
          VehiclesSelect,
          ClientBudgetsSelect,
          total,
          endOpen,
          price,
          days,
          line,
          category,
          ServicesSelectCmp,
          addDestination,
          removeDestination,
          handleLocationChange,
          onChangeProductCategory,
          onChangeProductGroup,
          onChangeDestinations,
          order,
          HeaderLinesSelect,
        }}
      />
    )
  }
}

OrderLineForm.propTypes = {}
OrderLineForm.defaultProps = {
  line: {},
  ServicesSelectCmp: Select,
  ProductsSelect: Select,
  formRef: { current: {} },
  addDestination: () => console.log('Not Implemented'),
  removeDestination: () => console.log('Not Implemented'),
  onChangeLineUOM: () => console.log('Not Implemented'),
  onChangeDestinations: () => console.log('Not Implemented'),
  handleLocationChange: () => console.log('Not Implemented'),
  type: 'new',
  destinations: [],
}

export default compose(Form.create(), withState('endOpen', 'setOpen', false))(OrderLineForm)
